<template>
  <div class="container counter-with-image-block">
    <div class="counter-with-image-block">
      <div class="row">
        <div class="col-sm-6 col-12 counter-with-image-block_row">
          <div
            v-for="(chunked_counters, chunk_index) in chunk_counters"
            class="row grid-row-gap-20">
            <counter-text
              v-for="(counter, index) in chunked_counters"
              class="col-6"
              :class="{gray_type: Boolean(chunk_index % 2 ? !index : index)}"
              :title="counter.title"
              :add_plus_symbol="counter.add_plus_symbol"
              :count_to="counter.number"
              :key="`counter_${chunk_index}_${uid}-${index}`">
            </counter-text>
          </div>
        </div>
        <div class="col-sm-6 col-12">
          <lazy-image
            class="counter-with-image-block__image"
            cover_img
            img_border_radius
            :src="image_src"
            :lazy_src="image_lazy_src"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CounterText from "../small_parts/CounterText.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import uid_mixin from "../../mixins/uid_mixin";
import WaveImageBlock from "../parts/builder/WaveImageBlock.vue";

export default {
  name: "CounterWithImageBlock",
  mixins: [uid_mixin],
  components: {WaveImageBlock, LazyImage, CounterText},
  props: {
    /**props**/
    image_src: {
      type: String,
      required: true,
      admin_type: 'image',
    },
    image_lazy_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    counters: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        number: {
          type: String,
          required: true,
          admin_type: 'number',
        },
        add_plus_symbol: {
          type: Boolean,
          default: false,
          admin_type: 'checkbox',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      }
    }
    /**props**/
  },
  computed: {
    chunk_counters() {
      let chunk_size = 2
      let chunks = [[]];

      let chunk_index = 0;
      this.counters.map(el => {
        if (chunks[chunk_index].length === chunk_size) {
          chunk_index++
          chunks[chunk_index] = []
        }
        chunks[chunk_index].push(el)
      })
      return chunks;
    },
  },
}
</script>
